/* ez-pdp-v2.js — Rediseño de la ficha de producto (PDP)
   Creado 2026-09-15 · prueba en B01 (template bodys-modeladores)
   2026-09-16: replicado a los 4 templates con productos activos.

   ⚠️ SIN SELECTOR DE CANTIDAD (decisión de Javier, 16-sep):
   "la sección de cantidad elimínalo, son muy pocas las personas que compran
   mas de uno del mismo producto, mientras mas simple este mejor".
   Se sacaron los chips 1/2/3 un, el stepper +/− de la ficha y el +/− de la
   barra fija. El botón ocupa el ancho completo y siempre agrega 1 unidad.
   El <input name="quantity"> de Dawn sigue en el DOM pero oculto por CSS:
   manda quantity=1, que es lo que se quiere, y revertir es una regla.

   EFECTO SECUNDARIO BUENO: el botón ya no puede mostrar un precio equivocado.
   Antes multiplicaba por la cantidad y había que predecir el descuento del
   combo; ahora muestra el precio unitario, que siempre es exacto. Lo único
   que habla del combo es un aviso de texto (ver PROMO abajo).

   Reemplaza al bloque sticky_atc_mobile anterior, que tenía un bug: hacía
   proxyBtn.disabled = realBtn.disabled, y un <button disabled> NO dispara
   click — la barra quedaba muerta si no había talla elegida.

   TRES GOTCHAS anotados para no repetirlos:
   1) Al cambiar de variante, Dawn RE-RENDERIZA el bloque de precio y el
      contenido del botón; lo que escribamos ahí se pierde. Por eso no se
      cachea el botón ni se observa el nodo del precio (Dawn lo reemplaza):
      se observa .product__info-container, que sí sobrevive. Ese observer es
      childList+subtree+characterData a propósito, NO sólo el atributo
      'disabled': Dawn también pisa el texto del botón al cambiar entre dos
      tallas DISPONIBLES (product-form.js escribe variantStrings.addToCart).
      Verificado el 16-sep: elegir 36 → 38 → 36 mantiene el total.
   2) El IntersectionObserver sobre la fila de compra NO dispara de forma
      fiable en esta ficha (el contenedor de info es position:sticky y hay
      apps que reescriben el árbol). Se usa un listener de scroll con rAF.
   3) El texto del botón se decide MIDIENDO si cabe, no por el ancho de
      pantalla. La medición se hace en un elemento aparte, NO escribiendo y
      volviendo a medir: escribir dispara el MutationObserver y alternaría
      los dos textos en bucle.

   2026-09-26: (a) el botón bloqueado ya no dice siempre "Elige tu talla":
   si la clienta ya eligió todo y la variante está agotada, lo dice (ver
   MOTIVO DEL BLOQUEO). (b) "exigirOpciones" para los trajes de baño: nada
   preseleccionado (ver NADA PRESELECCIONADO). (c) reaplicar() ya no pierde
   el último cambio de Dawn si llega dentro de los 40 ms del anterior.
   Correcciones de la revisión del mismo día: (d) con exigirOpciones el
   tachado de agotados se calcula con lo que TOCÓ la clienta, no con la talla
   que completó el servidor (antes el TB04 cargaba con Rojo tachado sin talla
   elegida); (e) con exigirOpciones el botón dice qué falta: "Elige el
   color" si ya eligió la talla y falta el color, "Elige tu talla" si falta
   la talla; (f) si la talla no tiene stock en ningún color: "Agotada en
   esta talla", sin nombrar un color que no eligió la clienta;
   (g) mientras carga, un "Sin stock" o "Elige…" que ya no corresponde pasa
   a "…"; (h) producto sin opciones y agotado: "Agotado" (antes pedía la
   talla); (i) el botón no se puede usar mientras Dawn trae la variante
   (ver GUARDIA DE LA VARIANTE); (j) con exigirOpciones, mientras falte
   elegir talla o color no se muestra el "Agotado" ni el "Notifícame" de
   una combinación que completó el servidor, y la galería no salta al color
   que la clienta no tocó (ver SIN "AGOTADO" INVENTADO).

   2026-10-16: (k) en las fichas con size_guard_talla, si la clienta toca
   un color antes que la talla, la talla que completa el servidor (S) ya no
   queda marcada ni deja el botón activo (ver TALLA SIN MARCAR).

   2026-10-17: (l) relanzamiento del Más x Menos. El aviso de la ficha habla
   de «prendas» (jeans y bodys), da el precio de ESTA ficha llevando 2 y
   llevando 3 o más, y enlaza a la página con el número de prendas de la
   colección. Colores del manual EZ v1.5 (sale el verde). Ver AVISO DEL COMBO.

   Todo es aditivo sobre el DOM de Dawn. Quitar el bloque revierte la ficha. */
(function () {
  'use strict';

  /* ══════════════════════════════════════════════════════════════
     AVISO DEL COMBO — espeja los descuentos AUTOMÁTICOS de Shopify
     Pedido de Javier (16-sep): "que la clienta sepa que ese producto lleva
     descuento si agrega otro mas".

     El mínimo de Shopify cuenta PRENDAS DE LA COLECCIÓN en el carrito, no
     unidades del mismo producto — o sea que el descuento se consigue igual
     llevando dos modelos distintos, que es como compra casi todo el mundo.
     Por eso el aviso habla de "prendas de la promo" y muestra el precio
     unitario con descuento, en vez de un total por cantidad.

     ⚠️ ESTO ES UNA COPIA DE UNA REGLA QUE VIVE EN EL ADMIN DE SHOPIFY.
     El storefront NO puede consultar los descuentos automáticos: no existe
     endpoint. SI JAVIER CAMBIA O APAGA UN DESCUENTO, HAY QUE TOCAR ESTA TABLA
     EL MISMO DÍA o el aviso va a prometer algo que no se cumple.

     Estado al 17-oct-2026 (relanzamiento del Más x Menos):
       Más x Menos → colección mas-x-menos-jeans (jeans Y bodys; el handle
                     conserva «jeans» porque la dirección no cambia)
                     2 prendas = 15% · 3 o más = 20%
       Luz Propia  → colección capsula-luz-propia
                     2 prendas = 15% · 3 o más = 25%   (¡ojo, 25 y no 20!)
     Cada tramo vale desde «min» prendas de la colección en el carro, sumando
     modelos distintos. El último tramo es «o más».
     ══════════════════════════════════════════════════════════════ */
  var PROMOS = {
    'mas-x-menos-jeans':  [{ min: 2, pct: 15 }, { min: 3, pct: 20 }],
    'capsula-luz-propia': [{ min: 2, pct: 15 }, { min: 3, pct: 25 }]
  };

  /* Texto del aviso por programa (banco de copy del 17-oct-2026):
       «Más x Menos: llevando 2 prendas, esta queda a $X; llevando 3 o más,
        a $Y. Mézclala con cualquier jean o body de la colección.
        Ver las {N} prendas →»
     X e Y salen del precio de ESTA ficha con los tramos de PROMOS. N es el
     número de prendas de la colección: se lee de /collections/<handle>.json
     (products_count) y se guarda 30 min en la pestaña. Mientras no llega
     (o si falla), el enlace dice «Ver las prendas →».
     Un programa sin entrada acá (Luz Propia) conserva el aviso anterior. */
  var AVISOS = {
    'mas-x-menos-jeans': {
      nombre: 'Más x Menos',
      mezcla: 'Mézclala con cualquier jean o body de la colección.',
      url: '/pages/lleva-mas-ahorra-mas'
    }
  };

  /* Nunca imprime un tramo en 0% (C13.4): los tramos sin % se saltan y, si
     no queda ninguno, devuelve '' y el aviso se esconde. */
  function avisoProgramaHtml(av, tramos, unit, n) {
    var ok = [];
    for (var i = 0; i < tramos.length; i++) {
      if (tramos[i].pct > 0) ok.push(tramos[i]);
    }
    if (!ok.length) return '';
    var frases = [];
    for (var j = 0; j < ok.length; j++) {
      var cuantas = ok[j].min + (j === ok.length - 1 ? ' o más' : '');
      var monto = '<b>' + pesos(unitarioConDescuento(unit, ok[j].pct)) + '</b>';
      frases.push(j === 0
        ? 'llevando ' + cuantas + ' prendas, esta queda a ' + monto
        : 'llevando ' + cuantas + ', a ' + monto);
    }
    var ver = n > 0 ? 'Ver las ' + n + ' prendas' : 'Ver las prendas';
    return '<strong>' + av.nombre + ':</strong> ' + frases.join('; ') + '. ' +
      av.mezcla + ' <a href="' + av.url + '">' + ver + ' →</a>';
  }

  /* ══════════════════════════════════════════════════════════════
     CYBER EZ (28-sep-2026)
     Durante el Cyber (clase ez-cy-on en <html>, la pone el snippet
     ez-cyber-estado) el botón y la barra fija muestran el precio Cyber,
     el aviso del combo se esconde (el Más x Menos está en pausa del 5 al
     7-oct) y, en los productos de un tramo, el bloque de «3 cuotas» (que
     calcula sobre el precio lleno) se oculta por CSS vía la clase
     ez-cy-prod en <main>. Los % NO viven acá: salen de window.EZ_CYBER,
     que lee el ajuste del theme «EZ · Cyber → Tramos» (las mismas
     colecciones que usa el descuento). Fuera del Cyber no cambia nada.
     ══════════════════════════════════════════════════════════════ */
  function cyberPct(cols) {
    var C = window.EZ_CYBER;
    if (!C || !C.tramos) return 0;
    var pct = 0;
    for (var i = 0; i < cols.length; i++) {
      var p = C.tramos[cols[i]];
      if (typeof p === 'number' && p > pct) pct = p;
    }
    return pct;
  }
  function cyberOn() {
    return document.documentElement.classList.contains('ez-cy-on');
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(fn, 0); });
    } else { setTimeout(fn, 0); }
  }

  /* Shopify guarda los precios en la unidad menor: $25.990 llega como 2599000.
     Y el formato de moneda de la tienda está con coma ("$25,990"), que en
     Chile se lee mal. Acá se arma a mano con punto de miles. */
  function pesos(centavos) {
    var n = Math.round((centavos || 0) / 100);
    return '$' + n.toLocaleString('es-CL').replace(/,/g, '.');
  }

  /* Réplica EXACTA de cómo Shopify calcula el descuento automático: aplica el
     % a CADA UNIDAD y redondea al peso. Verificado contra /cart.js en 6 casos
     con los dos programas (MB7007-2 a $19.990 y EZ2527 a $29.990).
     Calcularlo sobre el total en vez de por unidad da $1 de diferencia. */
  function unitarioConDescuento(unitCent, pct) {
    return Math.ceil((unitCent / 100) * (100 - pct) / 100) * 100;
  }

  /* "$25,990 CLP" -> "$25.990". Solo escribe si de verdad cambia, para no
     retroalimentar al MutationObserver. */
  function limpiarTextoPrecio(raiz) {
    if (!raiz) return;
    var nodos = raiz.querySelectorAll('.price-item');
    for (var i = 0; i < nodos.length; i++) {
      var el = nodos[i];
      var t = el.textContent;
      if (!t || t.indexOf('$') === -1) continue;
      var limpio = t.replace(/\s*CLP\s*/g, '').replace(/\$\s*([\d.,]+)/, function (_m, num) {
        return '$' + num.replace(/[.,]/g, '.');
      }).trim();
      if (limpio !== t.trim()) el.textContent = limpio;
    }
  }

  /* ¿Cabe este texto dentro del botón? Se mide en un span fuera de pantalla
     con la misma tipografía (ver gotcha 3). */
  var probe = null;
  function cabeEnBoton(b, texto) {
    if (!b || !b.clientWidth) return false;
    if (!probe) {
      probe = document.createElement('span');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText =
        'position:absolute;left:-9999px;top:0;white-space:nowrap;visibility:hidden';
      document.body.appendChild(probe);
    }
    var cs = window.getComputedStyle(b);
    probe.style.fontFamily = cs.fontFamily;
    probe.style.fontSize = cs.fontSize;
    probe.style.fontWeight = cs.fontWeight;
    probe.style.letterSpacing = cs.letterSpacing;
    probe.textContent = texto;
    var disponible = b.clientWidth -
      (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    return probe.getBoundingClientRect().width <= disponible;
  }

  onReady(function () {
    var dataEl = document.querySelector('[data-ez-pdp-data]');
    if (!dataEl) return;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var sectionId = cfg.sectionId;
    if (!sectionId) return;

    var mq = window.matchMedia('(max-width: 749px)');
    var main = document.querySelector('main') || document.body;
    main.classList.add('ez-pdp2');

    var info = document.querySelector('.product__info-container');
    var variantes = cfg.variants || [];

    /* ¿Este producto participa de algún combo?
       hasOwnProperty y no PROMOS[h] a secas: con corchetes, una colección
       llamada "constructor" devolvería una función de Object.prototype. */
    var promoTramos = null;
    var promoHandle = '';
    (function () {
      var hs = cfg.colecciones || [];
      for (var i = 0; i < hs.length; i++) {
        if (Object.prototype.hasOwnProperty.call(PROMOS, hs[i])) {
          promoTramos = PROMOS[hs[i]];
          promoHandle = hs[i];
          return;
        }
      }
    })();
    var promoAviso = (promoHandle && Object.prototype.hasOwnProperty.call(AVISOS, promoHandle))
      ? AVISOS[promoHandle] : null;

    /* «Ver las {N} prendas»: N = prendas de la colección (ver AVISOS). */
    var promoN = 0;
    function claveN() { return 'ez-promo-n:' + promoHandle; }
    function leerN() {
      try {
        var g = JSON.parse(window.sessionStorage.getItem(claveN()) || 'null');
        if (g && g.n > 0 && Date.now() - g.t < 1800000) return g.n;
      } catch (e) {}
      return 0;
    }
    function pedirN() {
      if (!window.fetch) return;
      fetch('/collections/' + encodeURIComponent(promoHandle) + '.json', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var n = (d && d.collection) ? parseInt(d.collection.products_count, 10) : 0;
          if (!(n > 0) || n === promoN) return;
          promoN = n;
          try {
            window.sessionStorage.setItem(claveN(), JSON.stringify({ n: n, t: Date.now() }));
          } catch (e) {}
          reaplicar();
        })
        .catch(function () {});
    }
    if (promoAviso) {
      promoN = leerN();
      if (!promoN) pedirN();
    }

    /* Cyber EZ: % del tramo de este producto (0 si no está en ninguno). */
    var cyPct = cyberPct(cfg.colecciones || []);
    if (cyPct) main.classList.add('ez-cy-prod');

    /* Nada de cachear el botón: Dawn puede reemplazarlo en cada cambio. */
    function getBtn() { return document.getElementById('ProductSubmitButton-' + sectionId); }
    function getPriceRoot() { return document.querySelector('.product__info-container .price'); }
    function getForm() {
      return document.querySelector('product-form form, form[action*="/cart/add"]');
    }

    var realBtn = getBtn();
    var btnsWrap = realBtn ? realBtn.closest('.product-form__buttons') : null;
    if (!realBtn || !btnsWrap) return;

    /* ══════════════════════════════════════════════════════════════
       MOTIVO DEL BLOQUEO (2026-09-26)
       Antes, todo botón deshabilitado decía "Elige tu talla". Pero Dawn
       también lo deshabilita cuando la clienta YA eligió y esa talla (o esa
       talla + color) está AGOTADA: el botón le volvía a pedir la talla y la
       barra fija la devolvía al selector, en loop. Casos reales: EZ2540 42,
       B11 M, B12 M / Rojo, TB01 M / Negro.
       Tres motivos:
         'falta'    → falta marcar algo: "Elige tu talla" o, si ya eligió la
                      talla y falta el color, "Elige el color".
         'agotada'  → está todo marcado y esa variante no se vende.
         'cargando' → Dawn está trayendo la variante nueva: no se toca el
                      texto, porque su JSON todavía es el de la anterior.
       La disponibilidad sale del JSON que Dawn deja en [data-selected-variant]
       y reemplaza en cada cambio, no de una copia propia.
       ══════════════════════════════════════════════════════════════ */
    function getPicker() { return document.getElementById('variant-selects-' + sectionId); }

    /* Cada grupo de opciones (Talla, Color…) con lo que tiene marcado. */
    function leerOpciones() {
      var picker = getPicker();
      var grupos = [];
      if (!picker) return grupos;
      var nodos = picker.querySelectorAll('fieldset, .product-form__input--dropdown');
      for (var i = 0; i < nodos.length; i++) {
        var marcado = nodos[i].querySelector('input:checked');
        var cualquiera = nodos[i].querySelector('input');
        var sel = nodos[i].querySelector('select');
        var valor = marcado ? marcado.value : (sel && sel.value ? sel.value : null);
        var nombre = (marcado || cualquiera || sel || nodos[i]).getAttribute('data-option-name');
        if (!nombre) {
          var leg = nodos[i].querySelector('legend, label');
          nombre = leg ? leg.textContent : '';
        }
        grupos.push({ nombre: nombre.trim(), valor: valor, nodo: nodos[i] });
      }
      return grupos;
    }

    function esTalla(n) { return /talla|size|tama/i.test(n); }
    function esColor(n) { return /color/i.test(n); }

    /* ¿Están TODOS los valores de este grupo marcados como agotados? Dawn usa
       dos clases (ver LECCIONES C10.6): 'disabled' en las píldoras y
       'visually-disabled' en los círculos de color. */
    function todoTachado(g) {
      var ins = g && g.nodo ? g.nodo.querySelectorAll('input[type="radio"]') : [];
      if (!ins.length) return false;
      for (var i = 0; i < ins.length; i++) {
        if (!ins[i].classList.contains('disabled') &&
            !ins[i].classList.contains('visually-disabled')) return false;
      }
      return true;
    }

    function motivoBloqueo(b, grupos) {
      /* Sin selector (producto de una sola variante), Dawn sólo deshabilita el
         botón cuando está agotado. */
      if (!getPicker()) return 'agotada';
      var faltan = 0;
      for (var i = 0; i < grupos.length; i++) {
        if (grupos[i].valor === null) faltan++;
      }
      if (faltan) {
        /* Con exigirOpciones el tachado sale de lo que tocó la clienta: si
           TODO lo que le falta elegir está tachado, lo que ya eligió no tiene
           stock con nada, y pedirle otra opción sería mandarla a un callejón. */
        if (exigir && faltan < grupos.length) {
          for (var f = 0; f < grupos.length; f++) {
            if (grupos[f].valor === null && todoTachado(grupos[f])) return 'agotada';
          }
        }
        /* Sin exigirOpciones, si Dawn ya está trayendo la variante es que la
           clienta tocó algo (size_guard_talla desmarca todo al cargar y el
           servidor completa el resto): no se le vuelve a pedir la talla. */
        if (!exigir && varianteEnCurso(b)) return 'cargando';
        return 'falta';
      }
      if (varianteEnCurso(b)) return 'cargando';
      var picker = getPicker();
      var dato = picker ? picker.querySelector('[data-selected-variant]') : null;
      if (!dato) return 'falta';
      var v;
      try { v = JSON.parse(dato.textContent); } catch (e) { return 'falta'; }
      if (v === null) return 'agotada';          // esa combinación no existe
      if (v.available) return 'falta';           // bloqueado por otra razón: como antes
      /* El JSON tiene que ser el de lo marcado; si no calza, Dawn todavía no
         terminó de reemplazarlo. */
      var ops = v.options || [];
      for (var j = 0; j < grupos.length; j++) {
        if (ops[j] !== undefined && ops[j] !== grupos[j].valor) return 'cargando';
      }
      return 'agotada';
    }

    function textoAgotada(grupos) {
      if (!grupos.length) return 'Agotado';
      if (grupos.length === 1) {
        return esColor(grupos[0].nombre) && !esTalla(grupos[0].nombre)
          ? 'Agotado en este color'
          : 'Agotada en esta talla';
      }
      /* Si la otra opción está TODA tachada, la talla elegida no tiene stock
         en ningún color: se dice así, sin nombrar un color que quizá completó
         el servidor y no la clienta (B11 M: antes "Sin stock en M · Rojo"). */
      if (grupos.length === 2) {
        for (var k = 0; k < 2; k++) {
          if (esTalla(grupos[k].nombre) && grupos[k].valor !== null &&
              todoTachado(grupos[1 - k])) return 'Agotada en esta talla';
        }
      }
      function peso(g) { return esTalla(g.nombre) ? 0 : (esColor(g.nombre) ? 1 : 2); }
      var orden = grupos.slice().sort(function (a, c) { return peso(a) - peso(c); });
      var vals = [];
      for (var i = 0; i < orden.length; i++) {
        if (orden[i].valor !== null) vals.push(orden[i].valor);
      }
      return 'Sin stock en ' + vals.join(' · ');
    }

    /* Qué pedirle cuando falta elegir algo. Antes decía siempre "Elige tu
       talla", aunque la talla ya estuviera elegida y faltara el color.
       Sólo con exigirOpciones: en las demás fichas size_guard_talla desmarca
       también el color, pero basta tocar la talla (el servidor completa el
       color), así que ahí sigue diciendo "Elige tu talla", como siempre. */
    function textoFalta(grupos) {
      if (!exigir) return 'Elige tu talla';
      var n = 0, t = 0, c = 0;
      for (var i = 0; i < grupos.length; i++) {
        if (grupos[i].valor !== null) continue;
        n++;
        if (esTalla(grupos[i].nombre)) t++;
        else if (esColor(grupos[i].nombre)) c++;
      }
      /* Falta la talla (sola o junto con el color): se pide la talla, que es
         lo primero del selector. Ya eligió la talla y falta el color: se pide
         el color. */
      if (!n || t) return 'Elige tu talla';
      if (n === c) return 'Elige el color';
      return 'Elige una opción';
    }

    /* El texto va por innerHTML (igual que el resto de la etiqueta): se escapa
       como lo serializa el navegador, para que la comparación no reescriba. */
    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    /* ══════════════════════════════════════════════════════════════
       GUARDIA DE LA VARIANTE (2026-09-26)
       Al elegir la PRIMERA talla en product.json, bodys-modeladores y
       ez2520-ulta-push-up, el bloque size_guard_talla habilita el botón en el
       mismo toque, mientras Dawn todavía trae la variante nueva (300-440 ms
       medidos). En ese lapso el formulario sigue con el id de la variante
       precargada (la talla 36 en EZ2540): si la clienta tocaba "Agregar",
       entraba al carro una talla que no eligió.
       Dawn marca ese lapso con product-info.pendingRequestUrl: lo pone al
       tocar una opción y lo borra justo antes de cambiar el id del
       formulario. Mientras esté puesto:
         - el botón se vuelve a deshabilitar en el mismo evento en que
           size_guard lo habilita, antes de que la clienta pueda tocarlo, y
           "Comprar ahora" se bloquea solo (script de buy-buttons.liquid);
         - como red de seguridad, el formulario no se envía.
       Acá nunca se habilita nada: al terminar, Dawn deja el botón según la
       variante nueva. Dawn ya deshabilita el botón en cada cambio de
       variante; esto sólo tapa el hueco que abre size_guard en el primero.
       ══════════════════════════════════════════════════════════════ */
    function varianteEnCurso(b) {
      var pi = (b && b.closest('product-info')) || document.querySelector('product-info');
      return !!(pi && pi.pendingRequestUrl);
    }

    function guardia() {
      var b = getBtn();
      if (!b || b.disabled) return;
      if (varianteEnCurso(b) || (exigir && faltaTocar()) || faltaTalla()) b.disabled = true;
    }

    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.querySelector || !f.querySelector('#ProductSubmitButton-' + sectionId)) return;
      if (!varianteEnCurso(getBtn())) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);

    /* ══════════════════════════════════════════════════════════════
       NADA PRESELECCIONADO (2026-09-26) — sólo si el template lo pide con
       "exigirOpciones": true en su JSON de datos. Hoy lo pide sólo
       product.tb01-caracteristicas.json (TB01, TB02 y TB04: trajes de baño,
       SIN cambio ni devolución).
       Dawn carga la ficha con la primera variante disponible ya marcada
       (XS / Rosa Fluor en el TB01) y el botón activo. Acá se desmarca todo y
       el botón queda bloqueado hasta que la clienta marque talla Y color.
       NO se copió el bloque size_guard_talla de product.json: su aviso
       "Quedan N unidades" lee el stock del PRIMER color (inventa escasez de
       otra combinación) y habilita el botón con sólo tocar un color.
       Cómo se sostiene contra Dawn: al tocar una opción, Dawn pide la ficha
       con lo marcado y el servidor COMPLETA lo que falta con la primera
       variante disponible (marcar sólo "M" vuelve como "M / Rosa Fluor").
       Por eso se recuerda qué tocó la clienta y, después de cada re-render,
       se desmarca lo que no tocó. Cuando marca lo último, Dawn pide la
       combinación exacta con todo lo marcado: la variante que va al carro es
       la que ella eligió. El "Comprar ahora" se bloquea solo cuando el botón
       está deshabilitado (script de snippets/buy-buttons.liquid).
       ══════════════════════════════════════════════════════════════ */
    var exigir = cfg.exigirOpciones === true;
    var tocadas = {};   // nombre de la opción -> valor que eligió la clienta

    /* TACHADO SEGÚN LO QUE TOCÓ LA CLIENTA (corrección 2026-09-26).
       Dawn tacha cada valor según la variante que el servidor dejó marcada,
       y aquí esa variante la completó el servidor, no ella: el TB04 cargaba
       con Rojo tachado ("agotado en XS", una talla que no se ve elegida)
       aunque XL / Rojo tiene 10 unidades. Así que, con exigirOpciones, el
       tachado se recalcula: un valor se tacha sólo si NO hay ninguna variante
       con stock que lo combine con lo que ella ya tocó en las otras opciones.
       Sin nada tocado, sólo se tacha lo que no tiene stock en ninguna
       combinación. Datos: "available" y "options" por variante, que manda el
       JSON del template. Si faltan, no se toca el tachado de Dawn.
       Cambiar clases no dispara el MutationObserver (sólo mira 'disabled'). */
    var conStock = [];
    var nOpciones = 0;
    if (exigir && variantes.length && variantes[0].options && variantes[0].options.length) {
      nOpciones = variantes[0].options.length;
      for (var k = 0; k < variantes.length; k++) {
        if (variantes[k].available === true && variantes[k].options) conStock.push(variantes[k].options);
      }
    }

    /* fijas: posición de la opción -> valor. ¿Hay alguna variante con stock
       que calce con todas? */
    function hayStock(fijas) {
      for (var i = 0; i < conStock.length; i++) {
        var calza = true;
        for (var p in fijas) {
          if (Object.prototype.hasOwnProperty.call(fijas, p) && conStock[i][p] !== fijas[p]) {
            calza = false;
            break;
          }
        }
        if (calza) return true;
      }
      return false;
    }

    function claveOpcion(input, i) { return input.getAttribute('data-option-name') || ('#' + i); }

    function gruposRadio(picker) {
      var out = [];
      var fs = picker.querySelectorAll('fieldset');
      for (var i = 0; i < fs.length; i++) {
        var ins = fs[i].querySelectorAll('input[type="radio"]');
        if (ins.length) out.push({ nodo: fs[i], inputs: ins, clave: claveOpcion(ins[0], i) });
      }
      return out;
    }

    function faltaTocar() {
      var picker = getPicker();
      if (!picker) return false;
      var gs = gruposRadio(picker);
      for (var i = 0; i < gs.length; i++) {
        if (!Object.prototype.hasOwnProperty.call(tocadas, gs[i].clave)) return true;
      }
      return false;
    }

    /* Deja en pantalla SÓLO lo que tocó la clienta. Escribe únicamente si algo
       difiere, para no alimentar al MutationObserver. */
    function aplicarExigencia(b) {
      if (!exigir) return;
      var picker = getPicker();
      if (!picker) return;
      var gs = gruposRadio(picker);
      var completo = true;
      /* Se recalcula el tachado sólo si cada grupo del selector calza con una
         opción del producto (mismo número y mismo orden que Dawn). */
      var marcar = nOpciones > 0 && gs.length === nOpciones;
      for (var i = 0; i < gs.length; i++) {
        var elegido = Object.prototype.hasOwnProperty.call(tocadas, gs[i].clave)
          ? tocadas[gs[i].clave] : null;
        var fijas = {};
        if (marcar) {
          for (var m = 0; m < gs.length; m++) {
            if (m !== i && Object.prototype.hasOwnProperty.call(tocadas, gs[m].clave)) {
              fijas[m] = tocadas[gs[m].clave];
            }
          }
        }
        var hay = false;
        for (var j = 0; j < gs[i].inputs.length; j++) {
          var inp = gs[i].inputs[j];
          var debe = elegido !== null && inp.value === elegido;
          if (inp.checked !== debe) inp.checked = debe;
          if (debe) hay = true;
          if (marcar) {
            fijas[i] = inp.value;
            var agotado = !hayStock(fijas);
            var clase = inp.classList.contains('swatch-input__input') ? 'visually-disabled' : 'disabled';
            if (inp.classList.contains(clase) !== agotado) inp.classList.toggle(clase, agotado);
          }
        }
        var rotulo = gs[i].nodo.querySelector('[data-selected-value]');
        var txt = hay ? elegido : '';
        if (rotulo && rotulo.textContent !== txt) rotulo.textContent = txt;
        if (!hay) completo = false;
      }
      if (!completo && !b.disabled) b.disabled = true;
    }

    if (exigir) {
      /* Se anota en CAPTURA, antes de que Dawn reaccione al cambio. */
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || t.type !== 'radio' || !t.closest) return;
        var picker = t.closest('variant-selects');
        if (!picker || picker.id !== 'variant-selects-' + sectionId) return;
        var gs = gruposRadio(picker);
        for (var i = 0; i < gs.length; i++) {
          if (gs[i].nodo.contains(t)) { tocadas[gs[i].clave] = t.value; return; }
        }
      }, true);

      /* Red de seguridad: aunque el botón quedara habilitado por un instante,
         el formulario no se envía mientras falte elegir algo. */
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f || !f.querySelector || !f.querySelector('#ProductSubmitButton-' + sectionId)) return;
        if (!faltaTocar()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var picker = getPicker();
        if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);

      aplicarExigencia(realBtn);
    }

    /* ══════════════════════════════════════════════════════════════
       TALLA SIN MARCAR (2026-10-16) — fichas con el bloque size_guard_talla
       y sin exigirOpciones (product.json, bodys-modeladores y
       ez2520-ulta-push-up).
       size_guard_talla desmarca todo al cargar, pero sólo esa vez. Si la
       clienta toca primero un COLOR, el servidor completa la talla con la
       primera (S) y Dawn vuelve a dibujar el selector con «S / Rojo»
       marcada y el botón activo: una talla que ella no eligió, en bodys que
       no tienen cambio (B14, 16-oct). Desde ese toque y hasta que toque una
       talla, después de cada re-render se desmarca la talla y el botón
       queda bloqueado con «Elige tu talla»; tampoco se ven el «Agotado» ni
       el «Notifícame» de esa talla que puso el servidor. El color que tocó
       queda marcado y la galería se mueve como siempre. Al tocar la talla,
       Dawn pide talla + color marcados: va al carro lo que ella eligió.
       Con la talla primero, el selector y el botón quedan como antes (el
       servidor completa el color). Nada se preselecciona (LECCIONES B1).
       Para revertir: guardaTalla = false.
       ══════════════════════════════════════════════════════════════ */
    var guardaTalla = !exigir &&
      !!document.querySelector('.size-guard[data-section="' + sectionId + '"]');
    var tallaTocada = false;
    var otraTocada = false;   // tocó un color (u otra opción) antes que la talla

    /* El grupo de radios de la talla, o null si el producto no tiene talla. */
    function grupoTalla(picker) {
      var fs = picker ? picker.querySelectorAll('fieldset') : [];
      for (var i = 0; i < fs.length; i++) {
        var ins = fs[i].querySelectorAll('input[type="radio"]');
        if (!ins.length) continue;
        var leg = fs[i].querySelector('legend');
        if (esTalla(ins[0].getAttribute('data-option-name') || (leg ? leg.textContent : ''))) {
          return { nodo: fs[i], inputs: ins };
        }
      }
      return null;
    }

    function faltaTalla() {
      return guardaTalla && otraTocada && !tallaTocada && !!grupoTalla(getPicker());
    }

    /* Desmarca la talla que puso el servidor y bloquea el botón. Escribe sólo
       si algo difiere, para no alimentar al MutationObserver. */
    function aplicarTalla(b) {
      if (!faltaTalla()) return;
      var g = grupoTalla(getPicker());
      for (var i = 0; i < g.inputs.length; i++) {
        if (g.inputs[i].checked) g.inputs[i].checked = false;
      }
      var rotulo = g.nodo.querySelector('[data-selected-value]');
      if (rotulo && rotulo.textContent !== '') rotulo.textContent = '';
      if (b && !b.disabled) b.disabled = true;
    }

    if (guardaTalla) {
      /* Se anota en CAPTURA, antes de que Dawn reaccione al cambio. */
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || t.type !== 'radio' || !t.closest) return;
        var picker = t.closest('variant-selects');
        if (!picker || picker.id !== 'variant-selects-' + sectionId) return;
        var g = grupoTalla(picker);
        if (g && g.nodo.contains(t)) tallaTocada = true;
        else otraTocada = true;
      }, true);

      /* Red de seguridad: el formulario no se envía mientras falte la talla. */
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f || !f.querySelector || !f.querySelector('#ProductSubmitButton-' + sectionId)) return;
        if (!faltaTalla()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var picker = getPicker();
        if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);
    }

    /* ══════════════════════════════════════════════════════════════
       SIN "AGOTADO" INVENTADO (2026-09-26) — sólo con exigirOpciones.
       Al tocar SÓLO la talla (XS, S o 2XL en el TB04) o SÓLO el color, el
       servidor completa la otra opción con la primera del producto (Rojo)
       aunque esté agotada en esa talla. Dawn pintaba el badge "Agotado"
       bajo el precio (y escondía el de "Oferta"), la app Vitals ponía el
       botón negro "Notifícame si está disponible" y la galería saltaba a la
       foto roja: escasez de una combinación que la clienta no eligió.
       Mientras falte tocar talla o color, o mientras Dawn trae la variante
       (el badge que hay nombra la combinación anterior), <main> lleva la
       clase ez-pdp2--eligiendo y el CSS de abajo esconde el badge y el
       Notifícame. Con las dos opciones elegidas y la variante ya cargada se
       ven como siempre: si ESA combinación está agotada, ahí corresponde.
       La clase está en <main>, fuera de lo que mira el MutationObserver, y
       sólo se escribe si cambia: no hace bucle. Se decide en el mismo
       evento en que Dawn re-renderiza, antes de pintar: no parpadea.
       ══════════════════════════════════════════════════════════════ */
    function marcarEligiendo() {
      if (!exigir && !guardaTalla) return;
      /* TALLA SIN MARCAR: mientras falte la talla, o mientras Dawn trae la
         variante después de que tocó un color (el badge que hay es el de la
         talla que puso el servidor). */
      var on = exigir
        ? (faltaTocar() || varianteEnCurso(getBtn()))
        : (faltaTalla() || (otraTocada && varianteEnCurso(getBtn())));
      if (main.classList.contains('ez-pdp2--eligiendo') !== on) {
        main.classList.toggle('ez-pdp2--eligiendo', on);
      }
    }

    /* La galería: Dawn la lleva a la foto de la variante que devuelve el
       servidor (product-info.updateMedia). Si la clienta no ha tocado el
       color, ese color lo puso el servidor: la galería no se mueve. Cuando
       toca un color, Dawn la mueve como siempre. Si algún día Dawn cambia el
       nombre del método, esto no hace nada y la galería se mueve como antes. */
    function colorSinTocar() {
      var picker = getPicker();
      if (!picker) return false;
      var gs = gruposRadio(picker);
      for (var i = 0; i < gs.length; i++) {
        if (esColor(gs[i].clave) &&
            !Object.prototype.hasOwnProperty.call(tocadas, gs[i].clave)) return true;
      }
      return false;
    }

    if (exigir || guardaTalla) {
      var stElige = document.createElement('style');
      stElige.textContent =
        '.ez-pdp2--eligiendo .product__info-container .price__badge-sold-out,' +
        '.ez-pdp2--eligiendo .product__info-container .Vtl-BackInStockButtonWrapper' +
        '{display:none!important}' +
        '.ez-pdp2--eligiendo .product__info-container .price--sold-out.price--on-sale' +
        ' .price__badge-sale{display:inline-block}';
      document.head.appendChild(stElige);
      marcarEligiendo();
    }

    if (exigir) {
      var piGaleria = realBtn.closest('product-info');
      if (piGaleria && typeof piGaleria.updateMedia === 'function') {
        var updateMediaDawn = piGaleria.updateMedia;
        piGaleria.updateMedia = function () {
          if (colorSinTocar()) return;
          return updateMediaDawn.apply(this, arguments);
        };
      }
    }

    function precioUnitario() {
      var form = getForm();
      var hidden = form ? form.querySelector('input[name="id"]') : null;
      var id = hidden ? parseInt(hidden.value, 10) : null;
      for (var i = 0; i < variantes.length; i++) {
        if (variantes[i].id === id) return variantes[i].price;
      }
      return variantes.length ? variantes[0].price : 0;
    }

    /* El estilo del aviso se inyecta sólo en las fichas que TIENEN promo
       (28 de 263 productos), no en el CSS que cargan las 263. */
    if (promoTramos) {
      var st = document.createElement('style');
      st.textContent =
        '.ez-pdp2 .ez-promo{font-size:1.3rem;line-height:1.5;margin:0 0 1.2rem;' +
        'padding:.9rem 1.2rem;border-radius:1rem;font-family:var(--font-body-family);' +
        'background:#FBF8F3;color:#121212;border:1px solid rgba(138,63,32,.35)}' +
        '.ez-pdp2 .ez-promo strong{font-weight:700;color:#121212}' +
        '.ez-pdp2 .ez-promo b{font-weight:700;color:#8A3F20}' +
        '.ez-pdp2 .ez-promo a{color:#121212;font-weight:700;text-decoration:underline;' +
        'text-underline-offset:.2em;white-space:nowrap}' +
        '.ez-pdp2 .ez-promo[hidden]{display:none}';
      document.head.appendChild(st);
    }

    /* Contenedor de compra: el aviso ARRIBA (se lee antes de decidir) y
       abajo el botón. Sin chips ni stepper. */
    var buy = document.createElement('div');
    buy.className = 'ez-buy';
    var promoEl = document.createElement('p');
    promoEl.className = 'ez-promo';
    promoEl.hidden = true;
    var promoHtml = null;
    var row = document.createElement('div');
    row.className = 'ez-buy__row';
    buy.appendChild(promoEl);
    buy.appendChild(row);
    btnsWrap.parentNode.insertBefore(buy, btnsWrap);
    row.appendChild(btnsWrap);
    var payWrap = btnsWrap.querySelector('.shopify-payment-button');
    if (payWrap) buy.appendChild(payWrap);

    /* Barra fija inferior (móvil): sólo el botón. */
    var vieja = document.getElementById('StickyATC-' + sectionId);
    if (vieja) vieja.remove();
    var sticky = document.createElement('div');
    sticky.className = 'ez-sticky2';
    sticky.hidden = true;
    sticky.innerHTML = '<button type="button" class="ez-sticky2__button" data-ez-add></button>';
    document.body.appendChild(sticky);
    var sAdd = sticky.querySelector('[data-ez-add]');

    /* El botón de la barra NUNCA se pone disabled: si falta la talla, lleva al
       selector. Ese era exactamente el bug de la versión vieja. */
    sAdd.addEventListener('click', function () {
      var b = getBtn();
      if (!b || b.disabled) {
        var picker = document.getElementById('variant-selects-' + sectionId) ||
                     document.querySelector('.product-form__input');
        if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      b.click();
    });

    function refrescar() {
      var b = getBtn();
      if (!b) return;

      /* Si Dawn recreó los botones, volver a meterlos en la fila. */
      var wrap = b.closest('.product-form__buttons');
      if (wrap && wrap.parentNode !== row) {
        row.appendChild(wrap);
        var pay = wrap.querySelector('.shopify-payment-button');
        if (pay) buy.appendChild(pay);
      }

      aplicarExigencia(b);
      aplicarTalla(b);
      marcarEligiendo();

      var bloqueado = b.disabled;
      var grupos = bloqueado ? leerOpciones() : [];
      var motivo = bloqueado ? motivoBloqueo(b, grupos) : '';
      var unit = precioUnitario();
      /* Cyber EZ: mismo cálculo que Shopify (por unidad, con piso). */
      var unitVisible = (cyPct && cyberOn()) ? unitarioConDescuento(unit, cyPct) : unit;
      var precioTxt = pesos(unitVisible);
      var etiqueta = cabeEnBoton(b, 'Agregar al carrito · ' + precioTxt)
        ? 'Agregar al carrito'
        : 'Agregar';

      if (motivo !== 'cargando') {
        var span = b.querySelector('span');
        if (span) {
          var deseado = !bloqueado
            ? etiqueta + ' <span class="ez-total">· ' + precioTxt + '</span>'
            : esc(motivo === 'agotada' ? textoAgotada(grupos) : textoFalta(grupos));
          if (span.innerHTML.trim() !== deseado) span.innerHTML = deseado;
        }

        var txtSticky = !bloqueado
          ? 'Agregar · ' + precioTxt
          : (motivo === 'agotada'
              ? (grupos.length ? 'Sin stock · elige otra' : 'Agotado')
              : textoFalta(grupos));
        if (sAdd.textContent !== txtSticky) sAdd.textContent = txtSticky;
      } else {
        /* Mientras Dawn trae la variante nueva no se sabe si hay stock. Si
           quedó el "sin stock" de la combinación ANTERIOR (nombraría una
           talla o color que ya no está marcado) o un "Elige…" (la clienta ya
           tocó una opción y el servidor completa el resto), se deja un
           texto neutro. */
        var viejo = /^(Sin stock|Agotad|Elige)/;
        var sp = b.querySelector('span');
        if (sp && viejo.test(sp.textContent.trim())) sp.innerHTML = '…';
        if (viejo.test(sAdd.textContent)) sAdd.textContent = '…';
      }
      sAdd.classList.toggle('is-locked', bloqueado);

      /* Aviso del combo: el precio que queda POR PRENDA. No es un total ni
         depende de cuántas se lleven de ESTE producto — sirve igual si la
         clienta suma otro modelo de la promo. */
      if (promoTramos && unit && !cyberOn()) {
        var html = '';
        if (promoAviso) {
          /* Más x Menos (17-oct): ver AVISOS. */
          html = avisoProgramaHtml(promoAviso, promoTramos, unit, promoN);
        } else {
          /* Luz Propia: aviso anterior, sin cambios. */
          var partes = [];
          for (var i = 0; i < promoTramos.length; i++) {
            var t = promoTramos[i];
            if (!t.pct) continue;
            partes.push('<b>' + t.min + '</b> a <b>' +
              pesos(unitarioConDescuento(unit, t.pct)) + '</b> c/u');
          }
          if (partes.length) {
            html = '🏷️ Promo por cantidad: llevando ' + partes.join(' · ') +
              '. Puedes combinar modelos.';
          }
        }
        if (html) {
          /* Se compara con lo último escrito y no con innerHTML: el enlace y
             la flecha podrían serializarse distinto y escribir en cada pasada
             (el MutationObserver de la ficha entraría en bucle). */
          if (promoHtml !== html) { promoEl.innerHTML = html; promoHtml = html; }
          promoEl.hidden = false;
        } else if (!promoEl.hidden) {
          promoEl.hidden = true;
        }
      } else if (!promoEl.hidden) {
        /* Cyber EZ: el Más x Menos está en pausa; el aviso del combo no se muestra. */
        promoEl.hidden = true;
      }
    }

    /* Reaplicar todo después de que Dawn re-renderice, sin entrar en bucle.
       2026-09-26: si llega un cambio mientras está en pausa, se reaplica UNA
       vez al terminar la pausa. Antes se perdía: si Dawn terminaba de traer
       la variante dentro de los 40 ms, el botón quedaba con el texto viejo.
       No hace bucle: la segunda pasada no escribe nada que ya esté igual. */
    var aplicando = false;
    var pendiente = false;
    function reaplicar() {
      if (aplicando) { pendiente = true; return; }
      aplicando = true;
      try {
        limpiarTextoPrecio(getPriceRoot());
        refrescar();
      } finally {
        setTimeout(function () {
          aplicando = false;
          if (pendiente) { pendiente = false; reaplicar(); }
        }, 40);
      }
    }

    /* guardia() va FUERA de la pausa de 40 ms de reaplicar(): tiene que
       deshabilitar el botón en el mismo microtask en que alguien lo habilita.
       Sólo escribe si el botón está habilitado, así que no hace bucle.
       marcarEligiendo() también va fuera: el "Agotado" que Dawn acaba de
       pintar se esconde antes de que se vea. Y aplicarTalla(): la S que
       Dawn acaba de marcar se desmarca antes de que se vea. */
    if (info && 'MutationObserver' in window) {
      new MutationObserver(function () { aplicarTalla(getBtn()); guardia(); marcarEligiendo(); reaplicar(); }).observe(info, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['disabled']
      });
    }

    /* Este listener está en document y en burbuja: corre DESPUÉS del de
       size_guard_talla (que está en el selector), en el mismo evento. */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-form__input')) {
        guardia();
        marcarEligiendo();
        setTimeout(reaplicar, 0);
      }
    });

    /* Cyber EZ: si el estado cambia con la ficha abierta (lun 00:00 o mié 23:59:59),
       el botón y la barra se actualizan solos. */
    document.addEventListener('ez:cyber', function () { reaplicar(); });

    /* Mostrar la barra cuando el botón real ya pasó hacia arriba.
       Scroll + rAF en vez de IntersectionObserver (ver gotcha 2 arriba). */
    var ticking = false;
    function evaluarSticky() {
      var b = getBtn();
      if (!b) return;
      var r = b.getBoundingClientRect();
      var mostrar = mq.matches && r.bottom < 0;
      if (sticky.hidden === mostrar) {
        sticky.hidden = !mostrar;
        if (mostrar) {
          requestAnimationFrame(function () { sticky.classList.add('is-visible'); });
        } else {
          sticky.classList.remove('is-visible');
        }
      }
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { evaluarSticky(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', function () { evaluarSticky(); refrescar(); }, { passive: true });

    reaplicar();
    evaluarSticky();
  });
})();
